module.exports = __webpack_public_path__ + "img/chevron-right-solid.5bbbb276.svg";